import script from "/app/pages/Home/status.vue?type=script";
import { render } from "/app/pages/Home/status.vue?type=template";
script.render = render;
export default script;
